import React, { forwardRef } from 'react'

import { twMerge } from 'tailwind-merge'

import Button, { type ButtonProps } from '@/components/common/Button'

const CancelButton: React.FC<ButtonProps> = ({
  children,
  disabled,
  ref,
  ...props
}) => {
  return (
    <Button
      type={props.type ?? 'button'}
      disabled={disabled}
      className={twMerge(
        'flex items-center justify-center h-6 rounded-[4px]',
        props.className,
      )}
      variant="outline"
      {...props}
    >
      <span className="text-[13px] text-primary-700 dark:text-primary-300">
        Cancel
      </span>
    </Button>
  )
}

CancelButton.displayName = 'RichTextArea.CancelButton'

export { CancelButton }
